import ContactUs from '../pages/contactUs/index.vue'
const routes = [
  {
    path: '/contactUs',
    name: 'ContactUs',
    component: ContactUs,
  },
];
export default routes